import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-24-地图-搜索",
  "use": "icon-24-地图-搜索-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 18 18\" id=\"icon-24-地图-搜索\">\n<g>\n\t<path d=\"M17,18c-0.13,0-0.61,0-1,0c-0.67-0.83-2-3-2-3c-0.34-0.53-0.27-0.69,0-1c0.37-0.41,1.5-0.5,2,0l2,2c0,0.29,0,0.41,0,1\n\t\tC18,17.27,17.26,18,17,18z\" />\n</g>\n<g>\n\t<path d=\"M8,16c-4.49,0-8-3.51-8-8c0-4.49,3.51-8,8-8c4.49,0,8,3.51,8,8C16,12.49,12.49,16,8,16z M8,2C4.64,2,2,4.64,2,8s2.64,6,6,6\n\t\ts6-2.64,6-6S11.36,2,8,2z\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol